import { mkDispatchLocal } from "./Common/CommonView.js";
import { singleton, delay, toList } from "../fable_modules/fable-library-js.4.19.3/Seq.js";
import { view as view_1 } from "./StentPlanning/StentPlanningView.js";
import { LocalMsg } from "./VisualizationTypes.js";
import { view as view_2 } from "./VisualizationTemp/VisualizationTempView.js";
import * as react from "react";

export function view(model, dispatch) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    const children = toList(delay(() => {
        const matchValue = model.VisualizationSubcomponentModel;
        return (matchValue.tag === 1) ? singleton(view_1(model.LoadingStatus, model.ImageData, matchValue.fields[0], (arg_1) => {
            dispatchLocal(new LocalMsg(10, [arg_1]));
        })) : singleton(view_2(model.LoadingStatus, model.ImageData, matchValue.fields[0], (arg) => {
            dispatchLocal(new LocalMsg(9, [arg]));
        }));
    }));
    return react.createElement("div", {}, ...children);
}

